// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'
import type { TAdminListParams } from '@/core/lib/table-query'

// Module Imports
import { teamEndpoints } from '@/modules/team/team.constants'
import type {
  TChangeTeamStatusRequest,
  TTeam,
  TTeamDetail,
  TTeamLogoRequest,
} from '@/modules/team/team.types'

export async function getTeamList(
  params: TAdminListParams
): Promise<TResponse<TTeam[]>> {
  const response = await api.get<TResponse<TTeam[]>>(teamEndpoints.list(params))

  return response.data
}

export async function getTeamDetail(id: string): Promise<TTeamDetail> {
  const response = await api.get<TResponse<TTeamDetail>>(
    teamEndpoints.detail(id)
  )

  return response.data.data
}

export async function changeTeamStatus(
  payload: TChangeTeamStatusRequest
): Promise<void> {
  await api.patch(teamEndpoints.updateStatus(payload.id), {
    status: payload.status,
  })
}

export async function deleteTeam(id: string): Promise<void> {
  await api.delete(teamEndpoints.delete(id))
}

export async function getPendingLogoRequests(): Promise<TTeamLogoRequest[]> {
  const response = await api.get<TResponse<TTeamLogoRequest[]>>(
    teamEndpoints.pendingLogoRequests()
  )

  return response.data.data ?? []
}

export async function approveLogoRequest(id: string): Promise<void> {
  await api.post(teamEndpoints.approveLogoRequest(id))
}

export async function refuseLogoRequest(payload: {
  id: string
  refuseReason: string
}): Promise<void> {
  await api.post(teamEndpoints.refuseLogoRequest(payload.id), {
    refuse_reason: payload.refuseReason,
  })
}
